import { axiosInstance } from '@configs/axios/axiosInstance';

import type {
  PostApprovalLetterRequest,
  PostLetterResult,
} from './postApprovalLetter.types';

export async function postApprovalLetter(
  params: PostApprovalLetterRequest
): Promise<PostLetterResult> {
  const formData = new FormData();
  formData.append('file', params.file);

  const response = await axiosInstance.post<PostLetterResult>(
    `/instructors/${encodeURIComponent(params.instructorId)}/requests/${encodeURIComponent(params.caseId)}/letters`,
    formData,
    {
      headers: {
        'X-Customer-Id': params.customerId,
        'Content-Type': 'multipart/form-data',
      },
      signal: params.signal,
    }
  );

  return response.data;
}
